import { memo } from 'react';

// Inverted-noise status pill for ERP grids.
//
// The reusable convention across modules:
//   - "active"   — quiet slate text, no fill. Active is the default
//                  for almost every row; loud green pills against
//                  hundreds of rows become visual noise.
//   - "inactive" — amber pill (calm "needs attention" tint).
//   - "blocked"  — rose pill (firm stop). Reserved for masters that
//                  are intentionally disabled (e.g., delisted vendor).
//
// Caller can pass either:
//   - value: 'active' | 'inactive' | 'blocked'  (string)
//   - value: boolean (true → active, false → inactive)
//   - value: any string — falls back to inactive styling, label = value
//
// We deliberately don't render this as an AntD <Tag> — AntD's tag
// chrome forces a small set of preset colours and adds a hover style
// that competes with the row-hover tint underneath.

const PRESETS = {
  active:   { className: 'erp-grid__status erp-grid__status--active',   label: 'Active'   },
  inactive: { className: 'erp-grid__status erp-grid__status--inactive', label: 'Inactive' },
  blocked:  { className: 'erp-grid__status erp-grid__status--blocked',  label: 'Blocked'  }
};

function resolveKey(value) {
  if (typeof value === 'boolean') return value ? 'active' : 'inactive';
  if (typeof value === 'string') {
    const k = value.toLowerCase();
    if (PRESETS[k]) return k;
  }
  return null;
}

function ErpDataGridStatusTag({ value, label, className = '' }) {
  const key = resolveKey(value);
  const preset = key ? PRESETS[key] : null;
  if (!preset) {
    return (
      <span className={`erp-grid__status erp-grid__status--inactive ${className}`}>
        {label || (value == null ? 'Unknown' : String(value))}
      </span>
    );
  }
  return (
    <span className={`${preset.className} ${className}`}>
      {label || preset.label}
    </span>
  );
}

export default memo(ErpDataGridStatusTag);
